export default "__VITE_PUBLIC_ASSET__eccf51da__"